import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  card: {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '12px',
    padding: '1.5rem',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: '0 8px 28px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)',
    },
    position: 'relative',
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
  },
  cardExpanded: {
    height: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.875rem',
    marginBottom: '1rem',
  },
  iconWrapper: {
    width: '42px',
    height: '42px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      color: '#4c4cff',
    },
  },
  titleContainer: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  countBadge: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 0,
  },
  countLabel: {
    fontSize: '0.625rem',
    color: '#9e9e9e',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 500,
    marginBottom: '0.125rem',
  },
  count: {
    fontWeight: 700,
    color: '#4c4cff',
    fontSize: '1.375rem',
    lineHeight: 1,
    padding: '0.25rem 0.625rem',
    backgroundColor: '#f0f0ff',
    borderRadius: '8px',
  },
  description: {
    color: '#5c5e6e',
    fontSize: '0.8125rem',
    lineHeight: 1.6,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    flex: 1,
  },
  descriptionCollapsed: {
    WebkitLineClamp: 3,
  },
  toggleButton: {
    marginTop: '0.5rem',
    background: 'none',
    border: 'none',
    color: '#4c4cff',
    cursor: 'pointer',
    fontSize: '0.8125rem',
    fontWeight: 500,
    padding: 0,
    textAlign: 'left',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    transition: 'color 0.15s',
    '&:hover': {
      color: '#3b3be0',
    },
  },
  chevron: {
    fontSize: '10px',
    display: 'inline-block',
    transition: 'transform 0.2s',
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
});

export default useStyles;
